<template>
  <a-modal
    :title="title"
    width="800px"
    :visible="true"
    :maskClosable="false"
    :confirmLoading="loading"
    cancelText="取消"
    okText="知道了"
    centered
    @ok="handleSubmit"
    @cancel="
      () => {
        // resetFields();
        $emit('cancel');
      }
    "
  >
    <a-row>
      <a-col :span="12">
        <a-card title="服务前">
          <a-image-preview-group>
            <a-image :width="108" v-for="img in before_image_list" :src="img.url" :key="img.url" />
          </a-image-preview-group>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="服务后">
          <a-image-preview-group>
            <a-image :width="108" v-for="img in after_image_list" :src="img.url" :key="img.url" />
          </a-image-preview-group>
        </a-card>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DoubleImageInfoModal',
  props: {
    before_image_list: {
      type: Array,
      required: true,
    },
    after_image_list: {
      type: Array,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const handleSubmit = (e: Event) => {
      e.preventDefault();

      emit('ok');
    };

    return {
      props,
      handleSubmit,
    };
  },
});
</script>
